module.exports = __webpack_public_path__ + "static/media/dice-five.88d0d4a9.svg";